<!-- 添加快录 -->
<template>
  <div class="addSnapshotFee">
    <div class="addTable">
      <!--基本信息-->
      <el-card class="mb5">
        <div slot="header">
          <span>{{ $t('collectionCenter.basicInformation') }}</span>
        </div>
        <el-form
          ref="basicInformation"
          :model="addBatchFee.basicInformation"
          label-position="top"
          size="mini"
        >
          <el-row :gutter="10">
            <el-col :span="6">
              <!--业务单号-->
              <el-form-item
                :label="$t('receivablePayable.TicketNumber') + '：'"
                prop="waybillNumber"
                :rules="[
                  { required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] },
                  { max: 30, message: $t('basicData.LengthCantExceed20'), trigger: ['blur', 'change'] }
                ]"
              >
                <div style="display:flex;">
                  <div style="width: 50px;font-weight: bold;text-align: center;">QR</div>
                  <el-input v-model="addBatchFee.basicInformation.waybillNumber" :disabled="!!queryFeeParam.id" />
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--客户-->
              <el-form-item
                :label="$t('receivablePayable.customer') + '：'"
                prop="customerId"
                :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
              >
                <QueryCustomerV2Cmp
                  style="width: 100%;"
                  :disabled="!!queryFeeParam.id"
                  :val="addBatchFee.basicInformation.customerId"
                  @change="val => addBatchFee.basicInformation.customerId = val"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--业务主体-->
              <el-form-item :label="$t('basicData.BusinessPrincipal') + '：'">
                <span>{{ providerName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--网点-->
              <el-form-item
                :label="$t('userManage.site') + '：'"
                prop="siteId"
                :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
              >
                <QuerySiteV2Cmp
                  style="width: 100%;"
                  provider-id=""
                  :disabled="!!queryFeeParam.id"
                  :val="addBatchFee.basicInformation.siteId"
                  @change="val => addBatchFee.basicInformation.siteId = val"
                  @row="changeOutlets"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--计费重量-->
              <el-form-item
                :label="$t('receivablePayable.BillableWeight') + '：'"
                prop="chargeWeight"
                :rules="{ required: true, suffix: 3, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
              >
                <el-input v-model="addBatchFee.basicInformation.chargeWeight" :disabled="!!queryFeeParam.id" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--业务类型-->
              <el-form-item
                :label="$t('collectionCenter.businessT') + '：'"
                prop="businessType"
                :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
              >
                <el-select
                  v-model="addBatchFee.basicInformation.businessType"
                  style="width: 100%;"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  :disabled="!!queryFeeParam.id"
                  @change="changeBusinessType()"
                >
                  <el-option
                    v-for="item in BUSINESS_TYPE"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <template v-if="addBatchFee.basicInformation.businessType === 1">
              <el-col :span="6">
                <!--揽收方式-->
                <el-form-item
                  :label="$t('collectionCenter.lanshouTypee') + '：'"
                  prop="collectType"
                  :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                >
                  <el-select
                    v-model="addBatchFee.basicInformation.collectType"
                    :placeholder="$t('basicData.PleaseSelect')"
                    style="width: 100%;"
                    :disabled="!!queryFeeParam.id"
                  >
                    <el-option
                      v-for="item in COLLECT_TYPE"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!--揽收类型-->
                <el-form-item
                  :label="$t('newOrder.CollectionType') + '：'"
                  prop="collectionCategory"
                  :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                >
                  <el-select
                    v-model="addBatchFee.basicInformation.collectionCategory"
                    :placeholder="$t('basicData.PleaseSelect')"
                    style="width: 100%;"
                    :disabled="!!queryFeeParam.id"
                  >
                    <el-option
                      v-for="item in COLLECTION_CATEGORY_TYPE"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </template>
            <el-col :span="6">
              <!--货物类型-->
              <el-form-item
                :label="$t('placeOrder.cargoType') + '：'"
                prop="cargoType"
                :rules="{ required: false, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
              >
                <el-select
                  v-model="addBatchFee.basicInformation.cargoType"
                  :placeholder="$t('basicData.PleaseSelect')"
                  style="width: 100%;"
                  :disabled="!!queryFeeParam.id"
                >
                  <el-option
                    v-for="(item, ind) in CARGO_TYPE"
                    :key="ind"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!--备注-->
              <el-form-item
                :label="$t('receivablePayable.remark') + '：'"
                prop="remark"
                :rules="{ max: 200, message: $t('basicData.LengthCantExceed200'), trigger: ['blur', 'change'] }"
              >
                <el-input
                  v-model="addBatchFee.basicInformation.remark" :rows="3" type="textarea"
                  :disabled="!!queryFeeParam.id"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
      <!--费用明细-->
      <el-card class="mb5">
        <div slot="header">
          <span>{{ $t('receivablePayable.FeeBreakdown') }}</span>
        </div>
        <el-form
          ref="addBatchFee"
          :model="addBatchFee"
          size="mini"
          class="error-form"
        >
          <el-table
            :key="expenseSubListKey"
            :data="addBatchFee.expenseSubList"
            :height="tableHeight"
            border
          >
            <el-table-column width="55" align="center">
              <template #header>
                <span class="el-icon-plus addStyle" @click="addCost" />
              </template>
              <template v-slot="scope">
                <!--确定删除吗？-->
                <el-popconfirm
                  :title="$t('basicData.AreYouSureDelete')"
                  @confirm="deleteCost(scope)"
                >
                  <span slot="reference" class="el-icon-delete deleteStyle" />
                </el-popconfirm>
              </template>
            </el-table-column>
            <!--业务类型-->
            <el-table-column
              prop="businessType"
              :label="$t('collectionCenter.businessT')"
              align="center"
              width="180"
            >
              <template #header>
                <div>
                  <span style="color: #f00;margin-right: 5px;">*</span>
                  <span>{{ $t('collectionCenter.businessT') }}</span>
                </div>
              </template>
              <template v-slot="scope">
                <div class="formStyle">
                  <div v-if="!scope.row.isEdit">
                    <span>{{ BUSINESS_TYPE[scope.row.businessType] && BUSINESS_TYPE[scope.row.businessType].label || '' }}</span>
                  </div>
                  <el-form-item
                    v-else
                    :prop="'expenseSubList.' + scope.$index + '.businessType'"
                    :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                  >
                    <el-select
                      v-model="scope.row.businessType"
                      filterable
                      :placeholder="$t('operationCenter.PleaseSelect')"
                      clearable
                      style="width: 100%;"
                      @change="businessTypeChange(scope)"
                    >
                      <el-option
                        v-for="item in businessTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <!--费用类型-->
            <el-table-column
              prop="feeName"
              :label="$t('basicData.ExpenseType')"
              align="center"
              width="180"
            >
              <template #header>
                <div>
                  <span style="color: #f00;margin-right: 5px;">*</span>
                  <span>{{ $t('basicData.ExpenseType') }}</span>
                </div>
              </template>
              <template v-slot="scope">
                <div class="formStyle">
                  <div v-if="!scope.row.isEdit">{{ scope.row.feeName }}</div>
                  <el-form-item
                    v-else
                    :prop="'expenseSubList.' + scope.$index + '.feeCode'"
                    :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                  >
                    <el-select
                      v-model="scope.row.feeCode"
                      filterable
                      clearable
                      :placeholder="$t('operationCenter.PleaseSelect')"
                      style="width: 100%;"
                      @change="feeTypeChange(scope)"
                    >
                      <el-option
                        v-for="item in scope.row.feeTypeOptionList"
                        :key="item.id"
                        :label="item.displayName"
                        :value="item.code"
                      />
                    </el-select>
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <!--应收金额-->
            <el-table-column
              prop="fee"
              :label="$t('receivablePayable.AmountReceivable')"
              width="120"
              align="center"
            >
              <template #header>
                <div>
                  <span style="color: #f00;margin-right: 5px;">*</span>
                  <span>{{ $t('receivablePayable.AmountReceivable') }}</span>
                </div>
              </template>
              <template v-slot="scope">
                <div class="formStyle">
                  <div v-if="!scope.row.isEdit">{{ scope.row.fee }}</div>
                  <el-form-item
                    v-else
                    :prop="'expenseSubList.' + scope.$index + '.fee'"
                    :rules="{ required: true, suffix: 2, negative: '-?', validator: priceType, trigger: ['blur', 'change'] }"
                  >
                    <el-input v-model="scope.row.fee" />
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <!--业务时间-->
            <el-table-column
              prop="operateTime"
              :label="$t('basicData.BusinessTime')"
              align="center"
              width="220"
            >
              <template #header>
                <div>
                  <span style="color: #f00;margin-right: 5px;">*</span>
                  <span>{{ $t('basicData.BusinessTime') }}</span>
                </div>
              </template>
              <template v-slot="scope">
                <div class="formStyle">
                  <div v-if="!scope.row.isEdit">{{ scope.row.operateTime }}</div>
                  <el-form-item
                    v-else
                    :prop="'expenseSubList.' + scope.$index + '.operateTime'"
                    :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                  >
                    <el-date-picker
                      v-model="scope.row.operateTime"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 100%;"
                      :placeholder="$t('basicData.SelectADatetime')"
                    />
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <!--备注-->
            <el-table-column
              prop="remark"
              :label="$t('receivablePayable.remark')"
              align="center"
              min-width="160"
            >
              <template v-slot="scope">
                <div v-if="!scope.row.isEdit">{{ scope.row.remark }}</div>
                <el-form-item
                  v-else
                  :prop="'expenseSubList.' + scope.$index + '.remark'"
                  :rules="{ max: 200, message: $t('basicData.LengthCantExceed200'), trigger: ['blur', 'change'] }"
                >
                  <el-input v-model="scope.row.remark" :placeholder="$t('GlobalSetObj.pleaseInputContent')" />
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </el-card>
    </div>
    <div class="footer">
      <!--关闭-->
      <el-button @click="saveData(1)">{{ $t('orderCenterCont.ShutDown') }}</el-button>
      <!--保存-->
      <el-button type="primary" @click="saveData(2)">{{ $t('basicData.Save') }}</el-button>
    </div>
  </div>
</template>

<script>
import {
  apiPayableSiteFastInputFee,
  apiSiteExpenseAddMultiFeeSub,
  apiReCalculateDeleteFeeDTO
} from '@/api/finance/receivables';
import { feePage } from '@/api/finance/partition';
import { cloneDeep } from 'lodash-es';
import QuerySiteV2Cmp from '@/views/finance/cmp/Query/QuerySiteV2Cmp.vue';
import QueryCustomerV2Cmp from '@/views/finance/cmp/Query/QueryCustomerV2Cmp.vue';
import { getOneBusinessTypeList } from './utils.js';
import { BUSINESS_TYPE, CARGO_TYPE, COLLECT_TYPE, COLLECTION_CATEGORY_TYPE } from '@/views/finance/enums';

export default {
  name: 'AddSnapshotFee',

  components: {
    QuerySiteV2Cmp,
    QueryCustomerV2Cmp
  },

  props: {
    // 基本信息
    queryFeeParam: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 费用类型
    feeTypeOption: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 费用明细
    expenseSubList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    const priceType = (rule, value, callback) => {
      const reg = new RegExp('(^' + rule.negative + '[1-9]\\d*(\\.\\d{1,' + rule.suffix + '})?$)|(^' + rule.negative + '0(\\.\\d{1,' + rule.suffix + '})?$)');
      const { required } = rule;
      if (!required) {
        // 非必填
        if (value) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$t('basicData.IncorrectFormatting'))); // 格式不正确
          } else {
            this.adopt = true;
            return callback();
          }
        } else {
          return callback();
        }
      } else {
        if (value) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$t('basicData.IncorrectFormatting'))); // 格式不正确
          } else {
            this.adopt = true;
            return callback();
          }
        } else {
          this.adopt = false;
          return callback(this.$t('basicData.CannotBeEmpty')); // '不能为空'
        }
      }
    };
    return {
      BUSINESS_TYPE,
      COLLECT_TYPE,
      COLLECTION_CATEGORY_TYPE,
      CARGO_TYPE,
      tableHeight: 200,
      addBatchFee: {
        basicInformation: {
          id: null,
          waybillNumber: '', // 业务单号
          customerId: '', // 客户id
          customerAlias: '', // 客户别称
          providerId: '', // 业务主体id
          siteId: '', // 网点id
          siteName: '', // 网点名称
          chargeWeight: '', // 计费重量
          businessType: '', // 业务类型
          collectType: '', // 揽收方式
          collectionCategory: '', // 揽收类型
          cargoType: '', // 货物类型
          remark: '', // 备注
          isSynchronous: false
        },
        expenseSubList: []
      },
      priceType,
      expenseSubListKey: new Date().getTime(),
      providerName: '' // 业务主体名称
    };
  },
  computed: {
    // 费用明细业务类型数据
    businessTypeList() {
      const { businessType } = this.addBatchFee.basicInformation;

      return getOneBusinessTypeList(businessType);
    }
  },
  watch: {
    queryFeeParam: {
      handler(val) {
        if (!val) {
          return;
        }
        this.addBatchFee.basicInformation = cloneDeep(val);
      },
      deep: true,
      immediate: true
    },
    expenseSubList: {
      handler(val) {
        console.log(val, '费用明细');
        if (!val.length) {
          return;
        }
        this.addBatchFee.expenseSubList = cloneDeep(val);
        this.expenseSubListKey = new Date().getTime();
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.getTableHeight();
  },

  mounted() {
    // 页面加载的时候设置table的高度
    this.getTableHeight();

    // 页面大小该变的时候（缩放页面）设置table的高度（可加可不加）
    window.onresize = () => {
      this.getTableHeight();
    };
  },
  methods: {
    // 获取table高度
    getTableHeight() {
      this.$nextTick(() => {
        const el = this.$refs.addBatchFee.$el;
        const top = el.offsetTop;
        this.tableHeight = document.body.clientHeight - (top + 87);
      });
    },
    // 基本信息业务类型变化
    changeBusinessType() {
      this.addBatchFee.basicInformation.collectionCategory = null;
      this.addBatchFee.basicInformation.collectType = null;
      if (!this.addBatchFee.basicInformation.id) {
        this.addBatchFee.expenseSubList = [];
      }
    },
    // 网点选项变化
    changeOutlets(obj) {
      const { label, providerName } = obj;
      this.addBatchFee.basicInformation.siteName = label;
      this.providerName = providerName; // 业务主体名称
    },
    // 费用类型变化
    feeTypeChange(scope) {
      this.addBatchFee.expenseSubList[scope.$index].feeTypeOptionList.map(item => {
        if (item.code === scope.row.feeCode) {
          this.addBatchFee.expenseSubList[scope.$index].feeName = item.name;
        }
      });
    },
    // 费用明细业务类型变化
    async businessTypeChange(scope) {
      this.addBatchFee.expenseSubList[scope.$index].feeName = '';
      this.addBatchFee.expenseSubList[scope.$index].feeCode = '';
      // 获取费用类型
      this.addBatchFee.expenseSubList[scope.$index].feeTypeOptionList = await this.getFeeType(scope.row.businessType);
    },
    /**
     * 保存/关闭
     * @param type 1 关闭 2 保存
     */
    saveData(type) {
      if (type === 1) {
        this.$emit('saveFormSnapshot', type);
        return;
      }
      if (type === 2) {
        const { basicInformation, expenseSubList } = this.addBatchFee;
        // 校验基础信息
        this.$refs.basicInformation.validate((valid) => {
          if (!valid) {
            return;
          }
          const formData = {
            id: basicInformation.id,
            waybillNumber: 'QR' + basicInformation.waybillNumber, // 业务单号
            businessType: basicInformation.businessType, // 业务类型
            customerId: basicInformation.customerId, // 客户id
            customerAlias: basicInformation.customerAlias, // 客户别称
            siteId: basicInformation.siteId, // 网点id
            siteName: basicInformation.siteName, // 网点名称
            providerId: null,
            remark: basicInformation.remark, // 备注
            cargoType: basicInformation.cargoType, // 货物类型
            collectType: basicInformation.collectType, // 揽收方式
            collectionCategory: basicInformation.collectionCategory, // 揽收类型
            chargeWeight: basicInformation.chargeWeight, // 计费重量
            isSynchronous: basicInformation.isSynchronous === true ? 1 : 0
          };
          // 校验费用明细
          this.$refs.addBatchFee.validate((valid) => {
            if (!valid) {
              return;
            }
            const list = [];
            expenseSubList.forEach(item => {
              if (item.isEdit === true) {
                const obj = {
                  id: item.id || '',
                  feeCode: item.feeCode,
                  businessType: item.businessType,
                  operateTime: item.operateTime,
                  remark: item.remark,
                  fee: item.fee,
                  feeName: item.feeName
                };
                list.push(obj);
              }
            });
            // 未新增数据不允许保存
            if (list.length === 0) {
              this.$message.warning(this.$t('basicData.noDataAddedCannotSave'));
              return;
            }

            const params = !formData.id
              ? {
                ...formData,
                expenseFastInputSubDTOList: list
              }
              : {
                waybillNumber: formData.waybillNumber,
                orderNumber: this.queryFeeParam.orderNumber,
                expenseSubList: list
              };

            console.log(params, '提交参数');
            const API = formData.id ? apiSiteExpenseAddMultiFeeSub : apiPayableSiteFastInputFee;
            API(params)
              .then(res => {
                const { code } = res;
                if (code === 200) {
                  this.$message.success(this.$t('GlobalSetObj.SaveSuccessfully')); // 保存成功
                  this.$emit('saveFormSnapshot', type);
                }
              })
              .catch(err => {
                console.error('API Error:', err);
              });
          });
        });
      }
    },
    // 删除新增
    deleteCost(scope) {
      if (scope.row.id) {
        apiReCalculateDeleteFeeDTO({ id: scope.row.id }).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
            this.addBatchFee.expenseSubList.splice(scope.$index, 1);
          }
        });
      } else {
        this.addBatchFee.expenseSubList.splice(scope.$index, 1);
      }
    },
    // 添加费用
    async addCost() {
      const { businessType } = this.addBatchFee.basicInformation;
      const feeList = await this.getFeeType(businessType);
      const data = {
        isEdit: true,
        businessType: businessType,
        feeName: '', // 费用类型
        feeCode: '', // 费用类型代码
        feeTypeOptionList: feeList,
        fee: '', // 应收金额
        remark: '', // 备注
        operateTime: '' // 生成业务时间
      };
      this.addBatchFee.expenseSubList.push(data);
    },
    // 获取费用类型
    getFeeType(type = '') {
      const param = {
        orderDirection: 'ASC',
        pageNumber: 1,
        pageSize: 999999,
        params: {
          state: 1,
          attribute: 1, // 1 应收费用 2 应付费用
          businessType: type
        }
      };
      return feePage(param, false).then(res => {
        const { code, data } = res;
        if (code === 200) {
          return data.records;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.addSnapshotFee {
  padding: 0 10px;

  .addTable {
    height: calc(100vh - 135px);
    overflow-y: auto;

    .addStyle {
      color: #409EFF;
      cursor: pointer;
      font-size: 18px;
    }

    .deleteStyle {
      color: #F56C6C;
      cursor: pointer;
      font-size: 18px;
    }
  }

  .footer {
    padding: 10px;
    text-align: right;
    border-top: 1px solid #ccc;
  }
}
</style>
